import { useEffect, useState } from "react";
import { api } from "../lib/api";

/** Full final text of a task. GET /tasks/{id} ships long results as a snippet (`final_output_snippet`, `final_output_chars`, `final_output: null`); the full text is fetched when `enabled`. */
export function useFinalOutput(task, enabled = true) {
  const [full, setFull] = useState(null);
  const [loading, setLoading] = useState(false);
  const id = task?.id;
  const chars = task?.final_output_chars || 0;
  const needsFetch = !!task && task.final_output == null && chars > 0;
  useEffect(() => { setFull(null); }, [id, task?.version, chars]);
  useEffect(() => {
    if (!enabled || !needsFetch || full != null || !id) return undefined;
    let alive = true;
    setLoading(true);
    api.get(`/tasks/${id}/final`).then((r) => { if (alive) setFull(r.data.final_output || ""); }).catch(() => { if (alive) setFull(""); }).finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [enabled, needsFetch, full, id]);
  const text = task?.final_output ?? full;
  return { text, snippet: task?.final_output_snippet || "", hasFinal: !!(task?.final_output || chars > 0), loading, ready: text != null };
}
